import React, {useEffect, useState} from "react";
import {Divider, Image, Popover} from "antd";
import CloudApi from "../../../cloud/cloud_api";
import imLoading from "../../iconfont/loading/imLoading.gif";

const GetImg = (props) => {
    const {item, wxid} = props
    const [fileSrc, setFileSrc] = useState('')

    useEffect(() => {
        if (item.pictureUrl) {
            setFileSrc(pictureUrl)
            return
        }
        if (item.msgType == 14 || item.msgType == 101 || item.msgType == 29) {
            let bodyData = {
                msgId: item.msg_unique_identifier,
                wxid: wxid,
                imageId: item.image_id || ''
            }
            CloudApi.getChatFileUrl(bodyData, data => {
                // setFileSrc('https://zk-cloud.oss-cn-beijing.aliyuncs.com/cdndownload/9ee9754701480d252cee5d76f6976fb1')
                if (data.url) {
                    setFileSrc(data.url)
                } else {
                    setFileSrc('noUrl')
                }
            }, error => {
            })
        }
    }, [])

    return (
        <>
            {/*{图片类型}*/}
            {
                item.msgType == 14 || item.msgType == 101 ?
                    <div className={'im-common'}>
                        {
                            fileSrc ?
                                <div>
                                    <Image
                                        preview={{src: (fileSrc) + '?x-oss-process=image/auto-orient,1/quality,q_80/format,webp'}}
                                        src={fileSrc}
                                        className={'im-img'}/>
                                    {
                                        item.loading != undefined ?
                                            <img src={imLoading}
                                                 className={'self_loading'}/> : ''
                                    }
                                </div> : ''
                        }
                    </div> : ''
            }
        </>
    )
}

const TextWithImg = (props) => {
    const {
        data, wxid, msg_unique_identifier,
    } = props

    return (
        <>
            {
                React.Children.map(props.children, child => {
                    return React.cloneElement(child, {});
                })
            }
            {  /**
             * 2文本  6位置 14图片 23视频 15文件 13链接 41名片 26红包 29GIF 16语音 78小程序
             */}
            {
                data.map(obj => {
                    obj.msgType = obj.subtype
                    obj.msg_unique_identifier = msg_unique_identifier
                    return (
                        <>
                            {
                                obj.subtype == 2 ?
                                    <div
                                        dangerouslySetInnerHTML={{__html: obj.content}}/> :
                                    obj.subtype == 14 ?
                                        <GetImg
                                            item={obj}
                                            wxid={wxid}>
                                        </GetImg> : ''
                            }
                        </>
                    )
                })
            }
        </>
    )
}

export default TextWithImg